export enum UserAddressingWaysWithLocalization {
    None,
    Mr,
    Mrs,
    Miss,
}
